import LabelledCheckbox from './LabelledCheckbox.component';

export default LabelledCheckbox;
